export const DecimalInputProps = {
  type: 'number' as const,
  step: 'any' as const,
};
